module.exports = __webpack_public_path__ + "img/delete.40348e44.svg";